import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deletedCardsGroupsChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiLockOpenVariantOutline } from '@mdi/js';

import { _ } from '../../functions/translator'
import { showMessage } from '../../functions/popUpMessage';


class ReopenButton extends React.Component{
          
    handleReopen = async () => {
        const closedAvailableText = this.getClosedAvailableText();
        const message = '¿' + _('Seguro que deseas reabrir estos protocolos') + '?' + ' ' + closedAvailableText;
        const messageConfig = {
            closeButton: true,
            reopenConfirm: true,
            cardsGroupIds: this.props.closedCardsGroupIds
        }
        showMessage(this.props, message, messageConfig);
        this.props.popUpMenuChange({ show: false });
        this.props.selectedCardsGroupsChange([]);
    }

    getClosedAvailableText = () => {
        const availableWord = this.props.closedCardsGroupIds.length > 1 ? 'disponibles' : 'disponible';
        const availableText = `(${this.props.closedCardsGroupIds.length} ${_(availableWord)})`;
        return availableText;
    }

    render(){   
        
        const closedAvailableText = this.getClosedAvailableText();
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={ this.handleReopen }>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiLockOpenVariantOutline } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Reabrir') }<span>{ closedAvailableText }</span></p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        deletedCardsGroupsChange : deletedCardsGroupsChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ReopenButton)